/*
 * 窗口弹窗(toast)
 *
 * @Author: xiaoJQ
 * @Date: 2024-05-15 16:25:35
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import { useSelector } from 'store/hook/useSelector';
import { CqPopUp_png } from 'image/index';
import Styles from './index.less';
function CqErrorLog(props) {
    var title = props.title, msg = props.msg, _a = props.onCancel, onCancel = _a === void 0 ? function () { } : _a, _b = props.onOk, onOk = _b === void 0 ? function () { } : _b;
    var handleCancel = useCallback(function () {
        onCancel();
    }, [onCancel]);
    var handleOk = useCallback(function () {
        onOk();
    }, [onOk]);
    return (React.createElement("div", { className: Styles.cqPopUpBox },
        React.createElement("div", { className: Styles.cqPopUpNav },
            React.createElement("div", { className: Styles.cqPopUpNavText }, title)),
        React.createElement("div", { className: Styles.cqPopUpBody },
            React.createElement("div", { className: Styles.cqPopUpBodyImg },
                React.createElement("img", { alt: '', src: CqPopUp_png })),
            React.createElement("div", { className: Styles.cqPopUpBodyMessage }, msg)),
        React.createElement("div", { className: Styles.cqPopUpFooter },
            React.createElement("button", { onClick: handleCancel, className: Styles.cqPopUpFooterBtn1 }, "\u53D6\u6D88"),
            React.createElement("button", { onClick: handleOk, className: Styles.cqPopUpFooterBtn2 }, "\u786E\u8BA4"))));
}
export default function PopupWindow() {
    var popup = useSelector(function (state) { var _a; return (_a = state.control) === null || _a === void 0 ? void 0 : _a.popup; });
    return (React.createElement("div", { style: { display: popup.show ? 'flex' : 'none' }, className: Styles.popupMask },
        React.createElement(CqErrorLog, __assign({}, popup.data))));
}
